export const customLabel = {
  methods: {
    customLabel : (option) => {
      return `${option.value}`
    }
  },
}
